module.exports = "<div class=\"__icon\"></div><div class=\"__content\"><div class=\"p --color-text-80\">{{ data.message }}</div></div>";